export const getLangFromPath = () => {
  const supportedLanguages = ['en', 'ar', 'fr']; // Add/remove supported languages as needed
  const { pathname } = window.location;
  const langFromPath = pathname?.split("/")[1];

  return supportedLanguages.includes(langFromPath) ? langFromPath : 'en';
};
